/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CodRegionStepComponent } from '../steps/region/region.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    AffectedItemsFormGroup,
    BillingAdjustmentDomesticFormGroup,
    CodCreateFormGroup,
    DeliveryErrorDomesticFormGroup,
    DeliveryErrorInternationalFormGroup,
    DocumentationInternationalFormGroup,
    EskerDomesticFormGroup,
    InvoiceErrorDomesticFormGroup,
    InvoiceErrorInternationalFormGroup,
    ItemOrQuantityDomesticFormGroup,
    ItemOrQuantityInternationalFormGroup,
    LargeInstrumentWarehouseDiscrepancyFormGroup,
    OrderEntryDomesticFormGroup,
    OrderEntryInternationalFormGroup,
    ProductDamageDomesticFormGroup,
    ProductDamageInternationalFormGroup,
    ProductDatingDomesticFormGroup,
    ProductDatingInternationalFormGroup,
    ProductTemperatureDomesticFormGroup,
    ProductTemperatureInternationalFormGroup,
    QualityInternationalFormGroup,
    ReferenceNumberDomesticFormGroup,
    ReferenceNumberInternationalFormGroup,
    RegionFormGroup
} from '../../models/cod-create.model';
import { StepConfig } from '../../../shared/types/step-config.type';
import { Store } from '@ngxs/store';
import { FormType } from '@cod-monorepo/interfaces';
import { CodReferenceNumberDomesticStepComponent } from '../steps/reference-number-domestic/reference-number-domestic.component';
import { EvaluateSteps, ResetReferenceNumber, UpdateFormValidity } from '../../state/cod.action';
import { CodReferenceNumberInternationalStepComponent } from '../steps/reference-number-international/reference-number-international.component';
import { CodOrderEntryDomesticStepComponent } from '../steps/order-entry-domestic/order-entry-domestic.component';
import { CodAffectedItemsStepComponent } from '../steps/affected-items/affected-items.component';
import { CodOrderEntryInternationalStepComponent } from '../steps/order-entry-international/order-entry-international.component';
import { CodItemOrQuantityDomesticStepComponent } from '../steps/item-or-quantity-domestic/item-or-quantity-domestic.component';
import { CodItemOrQuantityInternationalStepComponent } from '../steps/item-or-quantity-international/item-or-quantity-international.component';
import { CodProductDatingDomesticStepComponent } from '../steps/product-dating-domestic/product-dating-domestic.component';
import { CodProductDatingInternationalStepComponent } from '../steps/product-dating-international/product-dating-international.component';
import { CodProductDamageDomesticStepComponent } from '../steps/product-damage-domestic/product-damage-domestic.component';
import { CodProductDamageInternationalStepComponent } from '../steps/product-damage-international/product-damage-international.component';
import { CodAffectedItemsDamageDomesticStepComponent } from '../steps/affected-items-damage-domestic/affected-items-damage-domestic.component';
import { CodAffectedItemsDamageInternationalStepComponent } from '../steps/affected-items-damage-international/affected-items-damage-international.component';
import { CodProductTemperatureDomesticStepComponent } from '../steps/product-temperature-domestic/product-temperature-domestic.component';
import { CodProductTemperatureInternationalStepComponent } from '../steps/product-temperature-international/product-temperature-international.component';
import { CodDeliveryErrorDomesticStepComponent } from '../steps/delivery-error-domestic/delivery-error-domestic.component';
import { CodDeliveryErrorInternationalStepComponent } from '../steps/delivery-error-international/delivery-error-international.component';
import { CodDocumentationInternationalStepComponent } from '../steps/documentation-international/documentation-international.component';
import { CodInvoiceErrorDomesticStepComponent } from '../steps/invoice-error-domestic/invoice-error-domestic.component';
import { CodInvoiceErrorInternationalStepComponent } from '../steps/invoice-error-international/invoice-error-international.component';
import { CodAffectedItemsInvoiceErrorInternationalStepComponent } from '../steps/affected-items-invoice-error-international/affected-items-invoice-error-international.component';
import { CodBillingAdjustmentDomesticStepComponent } from '../steps/billing-adjustment-domestic/billing-adjustment-domestic.component';
import { CodQualityInternationalStepComponent } from '../steps/quality-international/quality-international.component';
import { CodAffectedItemsQualityInternationalStepComponent } from '../steps/affected-items-quality/affected-items-quality.component';
import { CodEskerDiscrepancyDomesticStepComponent } from '../steps/esker-discrepancy/esker-discrepancy-domestic.component';
import { CodLargeInstrumentWarehouseDiscrepancyStepComponent } from '../steps/large-instrument-warehouse-discrepancy/large-instrument-warehouse-discrepancy.component';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs';
import { RouterModule } from '@angular/router';
import { ButtonModule, DialogModule } from '@sag-ui';
import { CodAffectedItemsQuantityDomesticStepComponent } from '../steps/affected-items-quantity-domestic/affected-items-quantity-domestic.component';
import { CodAffectedItemsQuantityInternationalStepComponent } from '../steps/affected-items-quantity-international/affected-items-quantity-international.component';
import { CodAffectedItemsOrderEntryDomesticStepComponent } from '../steps/affected-items-order-entry-domestic/affected-items-order-entry-domestic.component';

@Component({
    selector: 'app-cod-create-form',
    templateUrl: './cod-create-form.component.html',
    imports: [
        CommonModule,
        CodRegionStepComponent,
        CodReferenceNumberDomesticStepComponent,
        CodReferenceNumberInternationalStepComponent,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        RouterModule,
        CodOrderEntryDomesticStepComponent,
        CodOrderEntryInternationalStepComponent,
        CodAffectedItemsStepComponent,
        CodItemOrQuantityDomesticStepComponent,
        CodItemOrQuantityInternationalStepComponent,
        CodProductDatingDomesticStepComponent,
        CodProductDatingInternationalStepComponent,
        CodProductDamageDomesticStepComponent,
        CodProductDamageInternationalStepComponent,
        CodAffectedItemsDamageDomesticStepComponent,
        CodAffectedItemsDamageInternationalStepComponent,
        CodProductTemperatureDomesticStepComponent,
        CodProductTemperatureInternationalStepComponent,
        CodDeliveryErrorDomesticStepComponent,
        CodDeliveryErrorInternationalStepComponent,
        CodDocumentationInternationalStepComponent,
        CodInvoiceErrorDomesticStepComponent,
        CodInvoiceErrorInternationalStepComponent,
        CodAffectedItemsInvoiceErrorInternationalStepComponent,
        CodBillingAdjustmentDomesticStepComponent,
        CodQualityInternationalStepComponent,
        CodAffectedItemsQualityInternationalStepComponent,
        CodEskerDiscrepancyDomesticStepComponent,
        CodLargeInstrumentWarehouseDiscrepancyStepComponent,
        CodAffectedItemsQuantityDomesticStepComponent,
        CodAffectedItemsQuantityInternationalStepComponent,
        CodAffectedItemsOrderEntryDomesticStepComponent,
        DialogModule
    ],
    standalone: true
})
export class CodCreateFormComponent implements OnInit, OnChanges {
    @Input({ required: true }) formGroup: FormGroup<CodCreateFormGroup>;
    @Input() readonly = false;
    @Input() disableValidation = false;
    @Input() steps: StepConfig[] = [];

    public formType = FormType;
    public regionForm: FormGroup<RegionFormGroup>;
    public referenceNumberDomesticForm: FormGroup<ReferenceNumberDomesticFormGroup>;
    public referenceNumberInternationalForm: FormGroup<ReferenceNumberInternationalFormGroup>;
    public orderEntryDomesticForm: FormGroup<OrderEntryDomesticFormGroup>;
    public orderEntryInternationalForm: FormGroup<OrderEntryInternationalFormGroup>;
    public affectedItemsForm: FormGroup<AffectedItemsFormGroup>;
    public itemOrQuantityDomesticForm: FormGroup<ItemOrQuantityDomesticFormGroup>;
    public itemOrQuantityInternationalForm: FormGroup<ItemOrQuantityInternationalFormGroup>;
    public productDatingDomesticForm: FormGroup<ProductDatingDomesticFormGroup>;
    public prodcutsDatingInternationalForm: FormGroup<ProductDatingInternationalFormGroup>;
    public productDamageDomesticForm: FormGroup<ProductDamageDomesticFormGroup>;
    public productDamageInternationalForm: FormGroup<ProductDamageInternationalFormGroup>;
    public prodcutTemperatureDomesticForm: FormGroup<ProductTemperatureDomesticFormGroup>;
    public prodcutTemperatureInternationalForm: FormGroup<ProductTemperatureInternationalFormGroup>;
    public deliveryErrorDomesticForm: FormGroup<DeliveryErrorDomesticFormGroup>;
    public deliveryErrorInternationalForm: FormGroup<DeliveryErrorInternationalFormGroup>;
    public documentationInternationalForm: FormGroup<DocumentationInternationalFormGroup>;
    public invoiceErrorDomesticForm: FormGroup<InvoiceErrorDomesticFormGroup>;
    public invoiceErrorInternationalForm: FormGroup<InvoiceErrorInternationalFormGroup>;
    public billingAdjustmentDomesticForm: FormGroup<BillingAdjustmentDomesticFormGroup>;
    public qualityInternationalForm: FormGroup<QualityInternationalFormGroup>;
    public eskerDiscrepancyForm: FormGroup<EskerDomesticFormGroup>;
    public largeInstrumentWarehouseDiscrepancyForm: FormGroup<LargeInstrumentWarehouseDiscrepancyFormGroup>;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initializeForm();
        if (!this.readonly && !this.disableValidation) {
            this.initWorkflowChangeListener();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disableValidation'] && !changes['disableValidation'].firstChange) {
            if (!this.disableValidation) {
                this.initWorkflowChangeListener();
            }
        }
    }

    protected initializeForm(): void {
        this.regionForm = this.formGroup!.get('region') as FormGroup<RegionFormGroup>;
        this.referenceNumberDomesticForm = this.formGroup!.get(
            'referenceNumberDomestic'
        ) as FormGroup<ReferenceNumberDomesticFormGroup>;
        this.referenceNumberInternationalForm = this.formGroup!.get(
            'referenceNumberInternational'
        ) as FormGroup<ReferenceNumberInternationalFormGroup>;
        this.orderEntryDomesticForm = this.formGroup!.get(
            'orderEntryDomestic'
        ) as FormGroup<OrderEntryDomesticFormGroup>;
        this.orderEntryInternationalForm = this.formGroup!.get(
            'orderEntryInternational'
        ) as FormGroup<OrderEntryInternationalFormGroup>;
        this.affectedItemsForm = this.formGroup!.get('affectedItems') as FormGroup<AffectedItemsFormGroup>;
        this.itemOrQuantityDomesticForm = this.formGroup!.get(
            'itemOrQuantityDomestic'
        ) as FormGroup<ItemOrQuantityDomesticFormGroup>;
        this.itemOrQuantityInternationalForm = this.formGroup!.get(
            'itemOrQuantityInternational'
        ) as FormGroup<ItemOrQuantityInternationalFormGroup>;
        this.productDatingDomesticForm = this.formGroup!.get(
            'productDatingDomestic'
        ) as FormGroup<ProductDatingDomesticFormGroup>;
        this.prodcutsDatingInternationalForm = this.formGroup!.get(
            'productDatingInternational'
        ) as FormGroup<ProductDatingInternationalFormGroup>;
        this.productDamageDomesticForm = this.formGroup!.get(
            'productDamageDomestic'
        ) as FormGroup<ProductDamageDomesticFormGroup>;
        this.productDamageInternationalForm = this.formGroup!.get(
            'productDamageInternational'
        ) as FormGroup<ProductDamageInternationalFormGroup>;
        this.prodcutTemperatureDomesticForm = this.formGroup!.get(
            'productTemperatureDomestic'
        ) as FormGroup<ProductTemperatureDomesticFormGroup>;
        this.prodcutTemperatureInternationalForm = this.formGroup!.get(
            'productTemperatureInternational'
        ) as FormGroup<ProductTemperatureInternationalFormGroup>;
        this.deliveryErrorDomesticForm = this.formGroup!.get(
            'deliveryErrorDomestic'
        ) as FormGroup<DeliveryErrorDomesticFormGroup>;
        this.deliveryErrorInternationalForm = this.formGroup!.get(
            'deliveryErrorInternational'
        ) as FormGroup<DeliveryErrorInternationalFormGroup>;
        this.documentationInternationalForm = this.formGroup!.get(
            'documentationInternational'
        ) as FormGroup<DocumentationInternationalFormGroup>;
        this.invoiceErrorDomesticForm = this.formGroup!.get(
            'invoiceErrorDomestic'
        ) as FormGroup<InvoiceErrorDomesticFormGroup>;
        this.invoiceErrorInternationalForm = this.formGroup!.get(
            'invoiceErrorInternational'
        ) as FormGroup<InvoiceErrorInternationalFormGroup>;
        this.billingAdjustmentDomesticForm = this.formGroup!.get(
            'billingAdjustmentDomestic'
        ) as FormGroup<BillingAdjustmentDomesticFormGroup>;
        this.qualityInternationalForm = this.formGroup!.get(
            'qualityInternational'
        ) as FormGroup<QualityInternationalFormGroup>;
        this.eskerDiscrepancyForm = this.formGroup!.get(
            'eskerDiscrepancyDomestic'
        ) as FormGroup<EskerDomesticFormGroup>;
        this.largeInstrumentWarehouseDiscrepancyForm = this.formGroup!.get(
            'largeInstrumentWarehouseDiscrepancy'
        ) as FormGroup<LargeInstrumentWarehouseDiscrepancyFormGroup>;

        if (this.readonly) {
            this.formGroup.disable();
        }
    }

    private initWorkflowChangeListener(): void {
        this.regionForm.controls.region.valueChanges
            .pipe(
                filter(value => !!value),
                debounceTime(200),
                filter(() => this.regionForm.valid),
                tap(() => {
                    this.store.dispatch(new ResetReferenceNumber());
                }),
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();

        this.referenceNumberDomesticForm.statusChanges
            .pipe(
                tap(status => this.store.dispatch(new UpdateFormValidity('referenceNumberDomesticStatus', status))),
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();

        this.referenceNumberDomesticForm.controls.natureOfComplaint.valueChanges
            .pipe(
                distinctUntilChanged(),
                tap(() => this.affectedItemsForm.controls.confirmed.setValue(false)),
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();

        this.referenceNumberInternationalForm.statusChanges
            .pipe(
                tap(status =>
                    this.store.dispatch(new UpdateFormValidity('referenceNumberInternationalStatus', status))
                ),
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();

        this.referenceNumberInternationalForm.controls.natureOfComplaint.valueChanges
            .pipe(
                distinctUntilChanged(),
                tap(() => this.affectedItemsForm.controls.confirmed.setValue(false)),
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();

        this.affectedItemsForm.statusChanges
            .pipe(
                debounceTime(200),
                tap(() => this.store.dispatch(new EvaluateSteps()))
            )
            .subscribe();
    }
}
